// ============================================================
// FXTM LANDING PAGE — MASTER CONTENT CONFIGURATION
// Edit everything here. No layout changes needed.
// ============================================================

export const SITE_CONFIG = {
    // --- ANALYTICS: paste your IDs here. Leave empty to disable. ---
    ga4MeasurementId: "", // e.g. "G-XXXXXXXXXX"
    gtmContainerId: "", // e.g. "GTM-XXXXXXX"

    // --- EDITABLE DESTINATIONS ---
    welcomeBonusUrl: "https://www.fxtm.com/en/rewards-promos/",
    instagramProfileUrl: "https://www.instagram.com/fxtm_africa/",

    brandName: "FXTM",
    region: "FXTM AFRICA",
};

const img = (id, w = 1400) =>
    `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&auto=format&fit=crop&w=${w}`;

// Shared bonus magnet line shown on every block
export const BONUS_TAG = "FREE $500 WELCOME BONUS";

// ============================================================
// THE FOUR BLOCKS — one object per Instagram destination
// ============================================================
export const STORIES = [
    {
        id: 1,
        slug: "profit-taking",
        category: "TRADING DISCIPLINE",
        visualHook: "$1,000 → $10",
        hook: "HE WAS UP $1,000. THEN IT WAS $10.",
        sub: "The thought every trader knows: “let me hold it just a little longer.”",
        image: img("photo-1689732888407-310424e3a372"),
        contentType: "Reel",
        typeLabel: "WATCH REEL",
        cta: "WATCH THE STORY",
        instagramUrl:
            "https://www.instagram.com/reel/DdbvoDcslag/?stkn=MTc4aXdobmF0aWoydw==",
        altText:
            "FXTM Reel — a trading chart showing profit falling from $1,000 to $10",
        accent: "orange",
        tileLabel: "PROFIT TAKING",
    },
    {
        id: 2,
        slug: "trader-education",
        category: "TRADER EDUCATION",
        visualHook: "RIGHT EDUCATION",
        hook: "EVERY TRADER STARTS SOMEWHERE. START RIGHT.",
        sub: "Education, market insights and tools that shape how you approach the market.",
        image: img("photo-1645736594095-b9a4cabc1a7c"),
        contentType: "Post",
        typeLabel: "VIEW POST",
        cta: "DISCOVER THE STORY",
        instagramUrl:
            "https://www.instagram.com/p/DceI7asucti/?stkn=OGJvYmpweW02Ymp3",
        altText:
            "FXTM creative — a trader starting with the right education",
        accent: "slate",
        tileLabel: "TRADER EDUCATION",
    },
    {
        id: 3,
        slug: "risk-management",
        category: "RISK MANAGEMENT",
        visualHook: "5 RISK MANAGEMENT RULES",
        hook: "5 RULES BEFORE YOU THINK ABOUT PROFIT.",
        sub: "How much to risk. Where to exit. What happens when the market turns.",
        image: img("photo-1611974789855-9c2a0a7236a3"),
        contentType: "Carousel",
        typeLabel: "VIEW POST",
        cta: "SEE THE 5 RULES",
        instagramUrl:
            "https://www.instagram.com/p/DbL5TnLjrcT/?stkn=MWJrZmdmNXRtcWY0bg==",
        altText:
            "FXTM Risk Management carousel — five rules every trader should understand",
        accent: "green",
        tileLabel: "RISK MANAGEMENT",
    },
    {
        id: 4,
        slug: "trading-mindset",
        category: "TRADING MINDSET",
        visualHook: "WHAT HAPPENS AFTER A LOSS?",
        hook: "YOU LOST THE TRADE. NOW WHAT?",
        sub: "Sometimes the biggest mistake isn’t the loss. It’s what happens next.",
        image: img("photo-1645226880663-81561dcab0ae"),
        contentType: "Reel",
        typeLabel: "WATCH REEL",
        cta: "WATCH THE STORY",
        instagramUrl:
            "https://www.instagram.com/reel/DdmA7mCMksn/?stkn=MXgydzhoODVjdmoxZw==",
        altText:
            "FXTM Reel — what happens emotionally after a losing trade",
        accent: "red",
        tileLabel: "TRADING MINDSET",
    },
];
